import React, { useEffect, useState } from 'react';
import styles from './event_detail_view_mobile.module.css';
import { AlertIconFill, CancelRedIcon, CheckMarkGreenIcon, EditIcon, MoreIcon, TrashIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Checkbox, Content, Dialog, DialogTrigger, Flex, Item, Link, Menu, TabList, TabPanels, Tabs, ToastQueue, View, MenuTrigger, ProgressCircle } from '@adobe/react-spectrum';
import { useTranslation } from 'react-i18next';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Button } from 'react-bootstrap';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import TinyMCEEditor from '../../../../components/ui/TinyMCEEditor/TinyMCEEditior';
import { SolutionStatusDropDown } from '../../task/components/SolutionStatusDropDown';
import { fromBase64Unicode } from '../../../../utils/helperUtil';
interface IEventDetailViewMobileProps {
  event: any;
  selectedDataRow: any,
  eventStatusList: any[];
  updateEventStatus: (isSelected: any, ident: any, isMulti: boolean) => void;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  selectedItem?: any;
  updateEventDescription: (description: string) => void;
  showUpdateLoader: boolean
}
const EventDetailViewMobile: React.FC<IEventDetailViewMobileProps> = ({
  event,
  selectedDataRow: any,
  eventStatusList,
  updateEventStatus,
  updateEventDescription,
  showUpdateLoader,
  onEdit, 
  onDelete,
}) => {

  const { t } = useTranslation('calendar');
  const _t = (key: string) => t(`calendar_detail.${key}`, { ns: 'calendar' });
  const _tt = (key: string) => t(`calendar_common.${key}`, { ns: 'calendar' });

  const [eventDescription, setEventDescription] = useState<string>('');
  const [checkSelected, setCheckSelected] = useState(false);
  
  useEffect(() => {
      if (event && event.description) {
        setEventDescription(fromBase64Unicode(event.description));
      }else{
        setEventDescription('')
      }
    }, [event])

  async function updateActivityStatus(e: any) {
    console.log('Selected status:', e.value);
    // let resActivity = await projectService.updateActivity(new UpdateActivityRequest(store.Server, store.SessionId, { ...activityData, customState: e.value }));
    // let status = activityStatusList.find((status: any) => status.id === e.value);
    // if (resActivity.result == 'OK') {
    //   await featureService.checkWorkFlowQueue(new CheckWorkFlowQueueRequest(store.Server, store.SessionId));
    //   ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    //   dispatch(setSelectedItem({ item: selectedItem ? { ...selectedItem, statusName: status.name, statusColor: statusColor(status.color) } : null, show_context: false }));
    // } else {
    //   ToastQueue.negative(resActivity.EXCEPTION?.message, { timeout: 1000 });
    // }
  }

  const handleEditClicked = () => {
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(event);
    }
  };

  const TaskCloseDialog = ({ close, taskId }: { close: () => void; taskId: any }) => (
    <Dialog size="S" UNSAFE_className={styles.close_pop_up_dialog} isDismissable={false}>
      <Flex UNSAFE_className={styles.close_pop_up_parent}>
        <Content UNSAFE_className={styles.close_pop_up_header}>{_t('close_event')}?</Content>
        <View UNSAFE_className={styles.close_pop_up_line}></View>
        <View UNSAFE_className={styles.close_pop_up_warning_text}>{_t('confirm_text')}</View>
        <View UNSAFE_className={styles.buttons_parent_close}>
          <View UNSAFE_className={styles.button_cancel}>
            <Link width={'155px'} UNSAFE_className={styles.close_pop_up_cancel_text} isQuiet onPress={() => {
              close();
              setCheckSelected(false);
            }}>
              {_t('button_cancel')}
            </Link>
          </View>
          <View UNSAFE_className={styles.button_confirm_close}>
            <Link UNSAFE_className={styles.close_pop_up_confirm_text} isQuiet onPress={() => {
              updateEventStatus(true, event.ident, false)
            }
            }>
              {_t('button_close')}
            </Link>
          </View>
        </View>
        <View UNSAFE_className={styles.ellipse_div}>
          <View UNSAFE_className={styles.close_alert_icon}>
            <AlertIconFill size={72} />
          </View>
        </View>
      </Flex>
    </Dialog>
  );

  const copyUrl = () => {
    const url = `${window.location.origin}/calendar?id=${event?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(_t('link_copied'), { timeout: 1000 });
  }

  return (
    <Flex width="100%" UNSAFE_style={{ padding: '12px' }} direction={'column'}>
      <Flex justifyContent={'space-between'} alignItems={'center'} direction={'row'}>
        <View>
          <SolutionStatusDropDown statusArray={eventStatusList} selectedStatus={event.status} onStatusChange={updateActivityStatus} />
        </View>
        <View UNSAFE_className={styles.icon_list_parent1}>
          <View UNSAFE_className={styles.icon_list_child}>
            <div className={styles.edit_icon} onClick={handleEditClicked}>
              <EditIcon size={32} />
            </div>
            <div className={styles.delete_icon} onClick={handleDeleteClicked}>
              <TrashIcon size={32} />
            </div>
            {event.isResolved ? (
              <Checkbox UNSAFE_style={{ marginTop: '5px' }} isDisabled isSelected={true} > Done</Checkbox>
            ) : (
              <>
                <DialogTrigger isDismissable type="modal">
                  <Checkbox UNSAFE_style={{ marginTop: '5px' }}
                    isSelected={checkSelected}
                    onChange={() => {
                      setCheckSelected(true);
                    }}
                  > <span style={{ color: '#5b6c74' }}>{_t('done')}</span></Checkbox>
                  {close => <TaskCloseDialog close={close} taskId={event.id} />}
                </DialogTrigger>
              </>
            )}
            <MenuTrigger>
              <ActionButton UNSAFE_style={{ border: 'none', alignItems: 'center', marginTop: '5px' }}><MoreIcon size={22} /></ActionButton>
              <Menu onAction={copyUrl}>
                <Item key={'copy'}>{_t('copy_link')}</Item>
              </Menu>
            </MenuTrigger>
          </View>
        </View>
      </Flex>
      <View UNSAFE_className={styles.header_main}>
        <View UNSAFE_className={styles.header_child}>
          <View UNSAFE_className={styles.frame_parent}>
            <View UNSAFE_className={styles.icon_activity_parent}>
              <b title={event?.title} className={styles.activity_name}>
                {event?.title?.length > 55 ? event?.title.substring(0, 55) + '...' : event?.title}
              </b>
            </View>
            {(event?.folderName || event?.projectName || event?.ProjectName || event?.activityName) && (
              <View UNSAFE_className={styles.folder_name_parent}>
                <View UNSAFE_className={styles.folder_name}>
                  {event?.folderName && (
                    <Link
                      isQuiet
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(event.folderId, 'folder')}
                    >
                      {event.folderName}
                    </Link>
                  )}

                  {event?.folderName && (event?.projectName || event?.ProjectName || event?.activityName) && (
                    <span> &gt; </span>
                  )}

                  {(event?.projectName || event?.ProjectName) && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(event.projectId, 'project')}
                    >
                      {event.projectName || event.ProjectName}
                    </Link>
                  )}

                  {(event?.projectName || event?.ProjectName) && event?.activityName && <span> &gt; </span>}

                  {event?.activityName && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(event.activityId, 'activity')}
                    >
                      {event.activityName}
                    </Link>
                  )}
                </View>
              </View>
            )}

            <View UNSAFE_className={styles.tag_parent} marginTop={'15px'}>
              <Flex direction={'column'} gap={'15px'} alignItems={'start'}>
                <Flex direction={'row'} gap={'size-400'}>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('location')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={event.dateFrom}>{event.location}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('begins')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.footer_wrapper}>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                          <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                            <span title={event.timeFrom}>{event.timeFrom}</span>
                          </View>
                          <View position={'relative'} width={'2px'} height={'20px'} UNSAFE_className={styles.pipe_sign}></View>
                          <div className={styles.footer_text_1}>{event.dateFrom} </div>
                        </Flex>
                      </Flex>
                    </Content>
                  </Flex>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('ends')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.footer_wrapper}>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                          <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                            <span title={event.timeTo}>{event.timeTo}</span>
                          </View>
                          <View position={'relative'} width={'2px'} height={'20px'} UNSAFE_className={styles.pipe_sign}></View>
                          <div className={styles.footer_text_1}>{event.dateTo} </div>
                        </Flex>
                      </Flex>
                    </Content>
                  </Flex>
                  {/* <Flex direction={'column'} gap={'size-100'} marginTop={'10px'} height={'calc(100% - 36px)'}>
                  <Divider orientation="vertical" size="S" height="40px" />
                </Flex> */}
                </Flex>
                <Flex direction={'row'} gap={'size-400'}>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('recurrence')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={event.isRepeat}>{event.isRepeat ? <CheckMarkGreenIcon size={16} /> : <CancelRedIcon size={16} />}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('private')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={event.isPrivate}>{event.isPrivate ? <CheckMarkGreenIcon size={16} /> : <CancelRedIcon size={16} />}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('chargeable')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={event.isChargeable}>{event.isChargeable ? <CheckMarkGreenIcon size={16} /> : <CancelRedIcon size={16} />}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('type')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={event.entryTypeName}>{event.entryTypeName}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                </Flex>
                <Flex direction={'row'} gap={'size-100'} marginTop={'10px'}>
                  <Flex direction={'column'} gap={'size-100'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('users')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'start'} gap={'16px'} wrap>
                        {String(event.userList || '')
                          .split(',')
                          .map(n => n.trim())
                          .filter(Boolean)
                          .map((name, idx) => (
                            <View
                              key={`${name}-${idx}`}
                              UNSAFE_style={{ fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                              <Avatar src="/assets/images/avatar--desktop--light@2x.png" alt={name} />
                              <span title={name}>{name}</span>
                            </View>
                          ))}
                      </Flex>
                    </Content>
                  </Flex>
                </Flex>
              </Flex>
            </View>
          </View>
        </View>
      </View>
      <View height={'100vh'}>
        <Tabs aria-label="Product detail" isEmphasized>
          <TabList>
            <Item key="product">{_t('overview')}</Item>
            <Item key="communication">{_t('communication')}</Item>
            <Item key="attachments">{_t('attachments')}</Item>
          </TabList>
          <TabPanels>
            <Item key="product">
              <Flex direction={'row'} marginTop="size-100">
                <Flex direction="column"
                  gap="size-100" gridArea="detail" width='100%'>
                  <View UNSAFE_className={styles.productMainTitle}>
                    {_t('description')}
                  </View>
                  <Flex
                    direction={'column'}
                    gap={'size-100'}
                  >
                    <Flex
                      direction={'column'}
                      position={'relative'}
                      width={'100%'}
                      height={'100%'}
                      alignItems={'start'}
                      justifyContent={'start'}
                      zIndex={0}
                      flex={1}
                      minHeight={'200px'}
                      gridRow={'20'}>
                      <TinyMCEEditor
                        key={'tiny_editor_mobile'}
                        initialValue={eventDescription}
                        onChange={(e: any) => {
                          setEventDescription(e);
                        }}
                        height={'100%'}
                      />
                    </Flex>
                    <Flex direction={'row'} justifyContent={'end'}>
                      <ProgressCircle aria-label='....Loading' isHidden={!showUpdateLoader} isIndeterminate UNSAFE_style={{ marginRight: '20px', marginTop: '10px' }} />
                      <Button variant="primary"
                        style={{ alignSelf: 'flex-end', marginTop: '10px', backgroundColor: '#0B5FFF', borderColor: '#0B5FFF' }}
                        onClick={() => { updateEventDescription(eventDescription) }}
                      >
                        {_tt('button_save')}
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Item>
          </TabPanels>
        </Tabs>
      </View>
    </Flex>
  );
};

export default EventDetailViewMobile;